import { CalendarDate } from '@internationalized/date';
import {
  DriverStatus,
  enumAddressType,
} from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useUpdateDriverMutation = createMutationHook(
  'transportation.driverUpdate',
  (params: {
    id: string;
    status?: DriverStatus;
    firstName?: string;
    lastName?: string;
    licenseNumber?: string;
    licenseExpiration?: CalendarDate;
    phoneNumber?: string;
    email?: string;
    defaultTruckId?: string | null;
    defaultTrailerId?: string | null;
    address?: {
      streetAddress: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
      addressType: (typeof enumAddressType)[keyof typeof enumAddressType];
      isMailingAddress: boolean;
    };
  }) => ({
    transportationDriverUpdate: {
      __args: {
        id: params.id,
        input: {
          ...(params.status !== undefined && { status: params.status }),
          ...(params.firstName !== undefined && {
            firstName: params.firstName,
          }),
          ...(params.lastName !== undefined && { lastName: params.lastName }),
          ...(params.licenseNumber !== undefined && {
            licenseNumber: params.licenseNumber,
          }),
          ...(params.licenseExpiration !== undefined && {
            licenseExpiration: params.licenseExpiration?.toString(),
          }),
          ...(params.phoneNumber !== undefined && {
            phoneNumber: params.phoneNumber,
          }),
          ...(params.email !== undefined && { email: params.email }),
          ...(params.defaultTruckId !== undefined && {
            defaultTruckId: params.defaultTruckId,
          }),
          ...(params.defaultTrailerId !== undefined && {
            defaultTrailerId: params.defaultTrailerId,
          }),
          ...(params.address !== undefined && { address: params.address }),
        },
      },
      id: true,
      status: true,
      firstName: true,
      lastName: true,
      licenseNumber: true,
      licenseExpiration: true,
      phoneNumber: true,
      email: true,
      defaultTruckId: true,
      defaultTrailerId: true,
      defaultTruck: { id: true, licensePlate: true },
      defaultTrailer: { id: true, licensePlate: true },
      address: {
        streetAddress: true,
        city: true,
        state: true,
        postalCode: true,
        country: true,
        addressType: true,
        isMailingAddress: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
